import { useParams } from 'react-router-dom'
import PageForm from './PageForm'

const View = () => {
    const params = useParams()

    return (
        <PageForm
            inPopup={false}
            id={parseInt(params.pageId)}
            config={{
                submitSuccessMsg: {
                    header: 'Updated',
                    message: 'Page updated successfully',
                },
                submitFailedMsg: {
                    header: 'Failed',
                    message: 'Failed to update page',
                },
                saveButton: {
                    label: 'Update',
                    savingLabel: 'Updating page...',
                },
            }}
        />
    )
}

export default View
